import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Box, Flex, HStack, Text, Icon, Menu, MenuButton, MenuList, MenuItem, Avatar, Button } from '@chakra-ui/react';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { FaCloud } from 'react-icons/fa';
import { removeToken, getUser } from '../utils/auth';

const HomePage = () => {
  const navigate = useNavigate();
  const user = getUser();

  const handleLogout = () => {
    removeToken();
    navigate('/login');
  };

  return (
    <Box minH="100vh" bgGradient="linear(to-br, #0a0e27, #1a1f3a, #2d1b4e)">
      <Box bg="transparent" px={6} py={0} h="64px">
        <Flex justify="space-between" align="center" h="100%">
          <HStack spacing={8}>
            <HStack spacing={2}>
              <Icon as={FaCloud} color="white" boxSize={5} />
              <Text color="white" fontSize="18px" fontWeight="bold">Automate Your Workflow</Text>
            </HStack>
            <HStack spacing={6}>
              <Text color="white" fontSize="14px" cursor="pointer" fontWeight="semibold" onClick={() => navigate('/home')}>Home</Text>
              <Text color="rgba(255,255,255,0.65)" fontSize="14px" cursor="pointer" onClick={() => navigate('/pipeline')}>Pipeline</Text>
              <Text color="rgba(255,255,255,0.65)" fontSize="14px" cursor="pointer" onClick={() => navigate('/monitoring')}>Monitoring</Text>
              <Text color="rgba(255,255,255,0.65)" fontSize="14px" cursor="pointer" onClick={() => navigate('/iac')}>IAC</Text>
            </HStack>
          </HStack>
          <Menu>
            <MenuButton as={Button} variant="ghost" color="white">
              <HStack spacing={2}>
                <Avatar size="sm" name={user?.sub || 'User'} />
                <Text fontSize="14px">{user?.sub || 'user@example.com'}</Text>
                <ChevronDownIcon />
              </HStack>
            </MenuButton>
            <MenuList>
              <MenuItem onClick={handleLogout}>Logout</MenuItem>
            </MenuList>
          </Menu>
        </Flex>
      </Box>
      <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 'calc(100vh - 64px)', padding: '0 16px', textAlign: 'center' }}>
        <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap', justifyContent: 'center' }}>
          <motion.button onClick={() => navigate('/pipeline')} style={{ padding: '16px 32px', fontSize: '18px', fontWeight: '600', color: 'white', background: 'linear-gradient(90deg, #9333ea, #2563eb)', borderRadius: '9999px', border: 'none', cursor: 'pointer', boxShadow: '0 10px 25px rgba(0,0,0,0.3)' }} initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ delay: 0.2, duration: 0.5 }} whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
            Pipeline
          </motion.button>
          <motion.button onClick={() => navigate('/monitoring')} style={{ padding: '16px 32px', fontSize: '18px', fontWeight: '600', color: 'white', background: 'linear-gradient(90deg, #9333ea, #2563eb)', borderRadius: '9999px', border: 'none', cursor: 'pointer', boxShadow: '0 10px 25px rgba(0,0,0,0.3)' }} initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ delay: 0.3, duration: 0.5 }} whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
            Monitoring
          </motion.button>
          <motion.button onClick={() => navigate('/iac')} style={{ padding: '16px 32px', fontSize: '18px', fontWeight: '600', color: 'white', background: 'linear-gradient(90deg, #9333ea, #2563eb)', borderRadius: '9999px', border: 'none', cursor: 'pointer', boxShadow: '0 10px 25px rgba(0,0,0,0.3)' }} initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }} transition={{ delay: 0.4, duration: 0.5 }} whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
            IAC
          </motion.button>
        </div>
      </div>
    </Box>
  );
};

export default HomePage;
